
import React, { useState, useEffect, useContext, createContext, Component } from 'react';
import ReactDOM from 'react-dom';
import serialize from 'form-serialize';
import axios from 'axios';
import { Route, Redirect, useParams } from 'react-router-dom';
import { Link, animateScroll as scroll } from "react-scroll";
import Header from '../../components/Header';

import {api_path} from '../../server.js'; 

import { matchPath, useLocation } from "react-router-dom";


function AnaliseSoloLaudo() {
  
    const [laudoId, setLaudoId] = useState();
    const [usuario, setUsuario] = useState();
    const [token, setToken] = useState();
    const [textoLaudo, setTextoLaudo] = useState();
    
    let query = new URLSearchParams(useLocation().search);
    var laudo_id = query.get("id");

    //console.log(laudo_id);
    useEffect(()=>{

        const storageUser = localStorage.getItem("SistemaUser");
        if(storageUser){
            let storageSistemaUser = JSON.parse(storageUser);
            //setLoading(false);
            let solo_id = storageSistemaUser.solo_id;
            let user_id = storageSistemaUser.user_id;
            let user_token = storageSistemaUser.user_token;
            setToken(user_token);
            setUsuario(user_id);

        }

        get_laudo();

    })

    function get_laudo(){
        const bodyFert = {
            acao: 'getLaudo',
            analise: laudo_id,
            usuario: usuario
          }
          axios.post(api_path()+'sistema/analisesolo/analise_solo_getLaudo.php', bodyFert, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then((response) => {
                let dadosAdubacao = response.data;
                let dadosAdubacaoTexto = dadosAdubacao.texto;
                setTextoLaudo(dadosAdubacaoTexto);
              })
              .catch(function (response) {
                  console.log(response);
              });
              return;
    }

    function createMarkup() {
        return {__html: textoLaudo};
      }
      

 //api_path()+'sistema/analisesolo/analise_solo_getLaudo.php
    const  url = api_path()+"sistema/analisesolo/laudoPDF.php?usuario="+usuario+'&laudo_id='+laudo_id;
     

    return (
      <div class="grid-container">
        <Header/>

        <nav role="navigation">
          <ul class="breadcrumbs">
              <li><a href="../dashboard">Home</a></li>
              <li>Análise de Solo</li>
            </ul>
          </nav>

        <div class="grid-x grid-padding-x">
          <div className="small-12 medium-12 large-12 cell">

            <div class="card">
              <div class="card-divider">
                  <h4>Recomendação</h4>
              </div>
              <div class="card-section">
                <div className="laudofinal" dangerouslySetInnerHTML={createMarkup()} />
              </div>
              <div class="card-section">
              <a className="button small secondary float-right" href ={url} target="_blank" rel="noopener noreferrer">Versão em PDF</a>
              </div>
            </div>

          </div>
        </div>
    </div>

    );
  }
  export default AnaliseSoloLaudo;